import {Button,Dialog,DialogActions,DialogContent,DialogTitle} from "@mui/material";
import React from "react";
import Lang from "../../../components/Lang";
import { useState } from "react";
import RadioGroupHT from "../../../components/RadioGroupHT";
import TeacherChoice from "../../../components/TeacherChoice";
import mut from "../../../hooks/mut";

export default function EditTeacherDialog(props) {
    const { open, setOpen, lesson,update } = props;
    const [teacher,setTeacher] = useState(lesson.teacher)
    const [future, setFuture] = useState("thisClass")
    
    const go = async () => {
        let res = await mut("post",`/class-timetable-change-teacher/${lesson._id}`, { teacher,tDate:lesson.tDate, future: future==="allFutureClasses" ? true : false })

        update(res)
        setOpen(false)
    }

  return (
    <Dialog open={open} fullWidth>
      <DialogTitle><Lang w="changeTeacher"/></DialogTitle>
          <DialogContent style={{display:"flex",flexDirection:"column", gap: 10}}>
               <RadioGroupHT
                        choices={["thisClass", "allFutureClasses"]}
                        value={future}
                        setValue={setFuture}
                        label={"changeFor"}
              />
        <TeacherChoice value={teacher} setValue={teacher=> setTeacher(teacher)} fullWidth/>
      </DialogContent>
      <DialogActions>
        <Button color="error" onClick={() => setOpen(false)}>Close</Button>
              <Button color="success" onClick={go}>Go</Button>
      </DialogActions>
    </Dialog>
  );
}